import { useState, useRef } from 'react'
import { motion, AnimatePresence, useInView } from 'framer-motion'
import { SPRING } from '@/lib/motion'

const TESTIMONIALS = [
  {
    quote: 'Ashu transformed our living room sofa. It looks brand new!',
    author: 'Selam T.',
    service: 'Sofa Cleaning',
    stars: 5,
    neighborhood: 'Bole'
  },
  {
    quote: 'Professional, punctual, and thorough. Best cleaning service in Addis.',
    author: 'Dawit M.',
    service: 'Home Deep Clean',
    stars: 5,
    neighborhood: 'Kazanchis'
  },
  {
    quote: 'My mattress has never felt fresher. Worth every birr!',
    author: 'Hiwot A.',
    service: 'Mattress Clean',
    stars: 5,
    neighborhood: 'Sarbet'
  },
  {
    quote: 'They cleaned our office after construction. Spotless work.',
    author: 'Abebe K.',
    service: 'Post-Construction',
    stars: 5,
    neighborhood: 'Megenagna'
  },
  {
    quote: 'Reliable and friendly team. Our go-to for holiday cleaning.',
    author: 'Meron B.',
    service: 'Holiday Package',
    stars: 5,
    neighborhood: 'CMC'
  }
]

export function Testimonials() {
  const [active, setActive] = useState(0)
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-80px' })

  const current = TESTIMONIALS[active]

  return (
    <section
      ref={ref}
      style={{
        background: 'var(--surface)',
        padding: 'var(--pad-section) max(5vw, 24px)'
      }}
    >
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          style={{ textAlign: 'center', marginBottom: 48 }}
        >
          <span
            style={{
              fontFamily: 'DM Sans',
              fontSize: '0.8rem',
              color: 'var(--lime)',
              letterSpacing: '0.15em',
              textTransform: 'uppercase'
            }}
          >
            Happy Customers · የተደሰቱ ደንበኞች
          </span>
          <h2
            style={{
              fontFamily: 'Bebas Neue',
              fontSize: 'var(--h2)',
              color: 'var(--white)',
              marginTop: 12
            }}
          >
            What They Say
          </h2>
        </motion.div>

        {/* Testimonial Card */}
        <AnimatePresence mode="wait">
          <motion.div
            key={active}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={SPRING}
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(232,255,0,0.08)',
              borderRadius: 24,
              padding: 48,
              position: 'relative'
            }}
          >
            {/* Quote mark */}
            <div
              style={{
                fontFamily: 'Bebas Neue',
                fontSize: '6rem',
                color: 'var(--lime)',
                opacity: 0.15,
                lineHeight: 1,
                position: 'absolute',
                top: 24,
                left: 24
              }}
            >
              "
            </div>

            {/* Stars */}
            <div style={{ display: 'flex', gap: 4, marginBottom: 24 }}>
              {Array.from({ length: current.stars }).map((_, i) => (
                <motion.span
                  key={i}
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: i * 0.1 }}
                  style={{ color: 'var(--lime)', fontSize: '1.2rem' }}
                >
                  ★
                </motion.span>
              ))}
            </div>

            {/* Quote */}
            <p
              style={{
                fontFamily: 'DM Sans',
                fontSize: '1.25rem',
                fontWeight: 500,
                color: 'var(--white)',
                lineHeight: 1.6,
                fontStyle: 'italic',
                marginBottom: 32
              }}
            >
              {current.quote}
            </p>

            {/* Author */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: '50%',
                  background: 'var(--lime)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: 'DM Sans',
                  fontWeight: 700,
                  color: 'var(--black)'
                }}
              >
                {current.author[0]}
              </div>
              <div>
                <div
                  style={{
                    fontFamily: 'DM Sans',
                    fontWeight: 700,
                    color: 'var(--white)'
                  }}
                >
                  {current.author}
                </div>
                <div
                  style={{
                    display: 'flex',
                    gap: 12,
                    fontFamily: 'DM Sans',
                    fontSize: '0.85rem',
                    color: 'var(--white-60)',
                    marginTop: 4
                  }}
                >
                  <span
                    style={{
                      background: 'var(--lime-dim)',
                      color: 'var(--lime)',
                      padding: '2px 8px',
                      borderRadius: 4,
                      fontSize: '0.75rem'
                    }}
                  >
                    {current.service}
                  </span>
                  <span>{current.neighborhood}</span>
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Dots */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 12,
            marginTop: 32
          }}
        >
          {TESTIMONIALS.map((_, i) => (
            <motion.button
              key={i}
              onClick={() => setActive(i)}
              style={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                border: 'none',
                cursor: 'pointer',
                background: i === active ? 'var(--lime)' : 'var(--white-10)'
              }}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
